import {
  lightErrorToast,
  lightSuccessToast,
} from "../../Components/customToast";
import requestMethods from "../../helpers/request";
import i18n from "../../i18n";
import { getStatus } from "../../services/serviceActions";
import { getAllAssignedTasks } from "../Home/homeActions";
import { setCancellationReasons, setEquipmentUrls } from "./slice";

export const updateClubbedTripStatus =
  (tripId, status, body, isUpdate, toNavigate) => async (dispatch) => {
    try {
      const res = await requestMethods.PUT({
        endpoint: `v1/shifter/clubbed/trip/mobile/update-trip-status/${tripId}/${status}`,
        body,
      });
      if (res.status) {
        if (isUpdate) isUpdate();
        if (toNavigate) toNavigate();
        lightSuccessToast(i18n.t("Status successfully updated"));
        dispatch(getStatus());
        dispatch(getAllAssignedTasks());
      }
    } catch (error) {
      if (isUpdate) isUpdate();
      lightErrorToast(error.message);
    }
  };

export const getCancellationNotes =
  (entityType, loader) => async (dispatch) => {
    try {
      const res = await requestMethods.GET({
        endpoint: `v1/shifter/trip/mobile/${entityType}/get-cancellation-notes`,
      });

      dispatch(setCancellationReasons(res));
      if (loader) loader();
    } catch (error) {
      if (loader) loader();
      lightErrorToast(error.message);
    }
  };

export const getEquipmentUrls = (ids, loader) => async (dispatch) => {
  try {
    const res = await requestMethods.POST({
      endpoint: `v1/shifter/trip/mobile/get-all-image-url`,
      body: {
        equipment_ids: ids,
      },
    });
    dispatch(setEquipmentUrls(res));
    if (loader) loader();
  } catch (error) {
    if (loader) loader();
    lightErrorToast(error.message);
  }
};
